import {GenericService, ResultType} from '@/shared/xhttp';
import {Tache} from '@/models';

export class TacheService extends GenericService<Tache> {
}